'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * A simple grid item
 */
var GridItem = function GridItem(_ref) {
  var xs = _ref.xs,
    sm = _ref.sm,
    staticCol = _ref.staticCol,
    flexCol = _ref.flexCol,
    children = _ref.children;
  var gridItemClassNames = (0, _classnames2.default)({
    'o-grid-col-1': xs === 1
  }, {
    'o-grid-col-2': xs === 2
  }, {
    'o-grid-col-3': xs === 3
  }, {
    'o-grid-col-4': xs === 4
  }, {
    'o-grid-col-5': xs === 5
  }, {
    'o-grid-col-6': xs === 6
  }, {
    'o-grid-col-7': xs === 7
  }, {
    'o-grid-col-8': xs === 8
  }, {
    'o-grid-col-9': xs === 9
  }, {
    'o-grid-col-10': xs === 10
  }, {
    'o-grid-col-11': xs === 11
  }, {
    'o-grid-col-12': xs === 12
  }, {
    'o-grid-col-sm-6': sm === 6
  }, {
    'o-grid-col-sm-12': sm === 12
  }, {
    'o-grid-col-static': staticCol
  }, {
    'o-grid-col-flex': flexCol
  });
  return _react2.default.createElement('div', {
    className: gridItemClassNames
  }, children);
};
GridItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The number of columns the item should span */
  xs: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /** The number of columns the item should span on small screen */
  sm: _propTypes2.default.oneOf([6, 12]),
  /** Whether the column adapts to its content */
  staticCol: _propTypes2.default.bool,
  /** Whether the column will fill the remaining space */
  flexCol: _propTypes2.default.bool,
  /** Children of the card (See CardBody and CardHeader) */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = GridItem;